import { render, staticRenderFns } from "./Nosotros.vue?vue&type=template&id=a3a2620c&scoped=true&"
var script = {}
import style0 from "./Nosotros.vue?vue&type=style&index=0&id=a3a2620c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a2620c",
  null
  
)

export default component.exports